import moment from 'moment';

const whitespaceOrEmpty = (message) => (v) =>
  (v || '').length > 0 || message;

const isInteger = (message) => (v) => !isNaN(parseInt(v)) || message;

const isDateAfter = (afterDate, message, format) => (date) => {
  return (
    moment(afterDate, format).isSameOrBefore(moment(date, format)) ||
    message
  );
};

const withinRange = (min, max, message) => (v) =>
  (min <= v && v <= max) || message;

export default {
  whitespaceOrEmpty,
  isInteger,
  isDateAfter,
  withinRange,
};
